import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FaCheck } from 'react-icons/fa';
import { MODULE_CLASSES } from './reportsCatalogData';

/**
 * A single report catalog card — a real <button>, module-colored icon tile,
 * title/subtitle, and a trailing selection check.
 */
function ReportCard({ report, selected, onSelect }) {
	const { Icon } = report;
	const moduleClasses = MODULE_CLASSES[report.module];

	return (
		<button
			type='button'
			aria-pressed={selected}
			onClick={() => onSelect(report.id)}
			className={classnames(
				'tw:flex tw:items-start tw:gap-3 tw:p-3.5 tw:bg-surface tw:border tw:rounded-panel tw:text-left tw:transition-[box-shadow,border-color,transform] tw:duration-100 tw:hover:shadow-raised tw:hover:-translate-y-px',
				selected ? classnames('tw:shadow-sm', moduleClasses.border) : 'tw:border-border',
			)}
		>
			<span
				className={classnames(
					'tw:flex tw:h-8 tw:w-8 tw:shrink-0 tw:items-center tw:justify-center tw:rounded-[9px] tw:text-white',
					moduleClasses.tile,
				)}
			>
				<Icon size={16} />
			</span>
			<span className='tw:flex tw:min-w-0 tw:flex-1 tw:flex-col tw:gap-0.5'>
				<span className='tw:text-[13.5px] tw:font-semibold tw:leading-[1.25] tw:tracking-[-0.005em] tw:text-ink-0'>
					{report.title}
				</span>
				<span className='tw:text-[11.5px] tw:leading-[1.35] tw:text-ink-3'>{report.subtitle}</span>
			</span>
			<span
				className={classnames(
					'tw:grid tw:h-[18px] tw:w-[18px] tw:shrink-0 tw:place-items-center tw:rounded-full tw:border-[1.5px] tw:transition-[border-color,background] tw:duration-100',
					selected ? moduleClasses.check : 'tw:border-border-strong',
				)}
			>
				{selected && <FaCheck size={9} className='tw:text-white' />}
			</span>
		</button>
	);
}

ReportCard.propTypes = {
	report: PropTypes.shape({
		id: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired,
		subtitle: PropTypes.string.isRequired,
		module: PropTypes.string.isRequired,
		Icon: PropTypes.elementType.isRequired,
	}).isRequired,
	selected: PropTypes.bool,
	onSelect: PropTypes.func.isRequired,
};

export default ReportCard;
